const getTransitionClassName = (animationState, classes) => {
  if (!animationState) {
    return '';
  }
  if (animationState === 'ADJUST') {
    return classes.adjustTransition;
  }
  if (animationState === 'MOVE') {
    return classes.moveTransition;
  }
  if (animationState === 'DRAG') {
    return classes.dragTransition;
  }
  throw new Error(`Unexpected animation state in #getTransitionClassName: ${animationState}`);
};
export default getTransitionClassName;